export default __webpack_public_path__ + "static/media/delivery.2efb0a7d.svg";